import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '../../../environments/environment';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-insert-captcha-dialog',
    templateUrl: './insert-captcha-dialog.html',
})
export class InsertCaptchaDialogComponent implements OnInit {

    public mainForm: FormGroup;
    public captchaUrl: string;

    constructor(
        public dialogRef: MatDialogRef<InsertCaptchaDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        public loc: LocalizationService) {

        this.mainForm = this.fb.group({
            captcha: ['', [
                Validators.required,
            ]]
        });

    }

    onSubmit() {
        this.dialogRef.close(this.mainForm.get('captcha').value);
    }

    closeDialog(): void {
        this.dialogRef.close(null);
    }

    ngOnInit() {
        this.captchaUrl = environment.captchaImageUrl + new Date().getTime();
    }


}



// WEBPACK FOOTER //
// ./src/app/dialogs/insert-captcha-dialog/insert-captcha-dialog.ts